import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { DashboardExport } from "../../../../assets/icons";
import { getInitials } from "../../../../util/general-helpers";
import { useSortableData } from "../../dashboard-util/dashboard-utils";
import ViewMembersPanelNew from "../../../../components/view-members-new/view-members-new";
import ArrowDown from "../../../../assets/icons/ArrowDown.svg";
import ArrowUp from "../../../../assets/icons/ArrowUp.svg";
import ArrowHover from "../../../../assets/icons/ArrowHover.svg";
import "../dashboard-group-head-tech.scss";

const GroupHeadDealTracker =  React.memo(( props ) => {
    const { title, departmentTitle, exportData, renderExtraColumns, exportDisabled, showModal } = props;
    const { items, requestSort, getArrowDirectionFor } = useSortableData(props.items);

    return (
        <div className="new-dashboard table-wrapper mt-4">
            <div className="DashboardTableWrapper TechDashboard">
                <div>
                    <div className="DashboardTableHeader">
                        <th className="DashboardTableTitle">
                            <span>{title}</span>
                            <button
                                key="download"
                                className={`DashboardTableHeaderButtons bg-transparent ${
                                    exportDisabled ? 'dashboard-export-button-disabled' : ''
                                }`}
                                onClick={exportData}
                                onKeyDown={exportData}
                                tabIndex="0"
                                data-testid="export-button"
                                disabled={exportDisabled}
                            >
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Export Data</Tooltip>}
                                >
                                <img src={DashboardExport} alt="Export Tech" />
                                </OverlayTrigger>
                            </button>
                            <div className="subDepartmentTitle">{departmentTitle}</div>
                        </th>
                    </div>
                </div>
                {   items?.length > 0 &&
                    <table className="TechDashboardTable scrollable-dashboard">
                        <thead className="MemberTableColumnHeader techHeader sticky-header-dashboard">
                            <tr className="tableColumnTitles tableHeader">
                                <th className="col-md-1 col-sm-1 textEllipsis headerSorted">
                                    <div onClick={() => requestSort("ProjectName")} className={'sortedCenter'}>
                                        <div className="containerTextSorted">
                                            <p className="textSorted">Project Name</p>
                                        </div>
                                        {   getArrowDirectionFor("ProjectName", "descending") &&
                                            <img className="arrowDirection" alt="Arrow down" src={ArrowDown} />
                                        }
                                        {   getArrowDirectionFor("ProjectName", "ascending") &&
                                            <img className="arrowDirection" alt="Arrow up" src={ArrowUp} />
                                        }
                                        {   getArrowDirectionFor("ProjectName") &&
                                            <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover} />
                                        }
                                    </div>
                                </th>
                                <th className="col-md-3 col-sm-3 textEllipsis headerSorted">MD/D/VP</th>
                                <th className="col-md-3 col-sm-3 textEllipsis headerSorted">Members</th>
                                <th className="col-md-3 col-sm-3 textEllipsis headerSorted">Staffer</th>
                                <th className="col-md-1 col-sm-1 techQtyColumn headerSorted"># of Associates / Analysts</th>
                                <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Total Hours</th>
                                <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Last Week Hours</th>
                                <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Weekend Hours</th>
                                <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Current Week Hours</th>
                            </tr>
                        </thead>
                        <tbody className="tableBody techBody" data-testid="table-body">
                            {   items.map((item) => {
                                    return (
                                        <tr key={item?.DashboardKey} className={""}>
                                            <td className={`col-md-2 col-sm-1 mt-2 hover`}
                                                onClick={() => showModal(item)}
                                                data-testid={`project-name-${item.ProjectName}`}
                                            >
                                                <div className="rowContainer">
                                                    {item.ProjectName}
                                                </div>
                                            </td>
                                            <td className="col-md-3 col-sm-3 mt-2 techMemberColumn">
                                                <ViewMembersPanelNew
                                                    members={item.GroupHeads || []}
                                                    projects={item.Project}
                                                    isHidden={true}
                                                />
                                            </td>
                                            <td className="col-md-3 col-sm-3 mt-2 techMemberColumn">
                                                <ViewMembersPanelNew
                                                    UserID={item.Project?.Owner?.Id}
                                                    members={item.Project?.Members || []}
                                                    projects={item.Project}
                                                    isHidden={true}
                                                />
                                            </td>
                                            <td className="col-md-3 col-sm-3 mt-2"
                                                data-testid={`staffer-name-${item.Staffer.Name}`}
                                            >
                                                <div className="rowContainer">
                                                    <div className="rowIconContainer">
                                                        <div className={`member-icon-user d-flex align-items-center`}>
                                                            <div className={`member-icon-initials-user`}>
                                                                {getInitials(item.Staffer.Name)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {item.Staffer.Name}
                                                </div>
                                            </td>
                                            <td className="col-md-1 col-sm-1 mt-2">
                                                {item.QtyMembers}
                                            </td>
                                            <td className="col-md-1 col-sm-1 mt-2">
                                                {item.AggregateTotalHours}
                                            </td>
                                            <td className="col-md-1 col-sm-1 mt-2">
                                                {item.AggregateLastWeekHours}
                                            </td>
                                            <td className="col-md-1 col-sm-1 mt-2">
                                                {item.AggregateWeekendHours}
                                            </td>
                                            <td className="col-md-1 col-sm-1 mt-2">
                                                {item.AggregateCurrentWeekHours}
                                            </td>
                                            {renderExtraColumns?.(item)}
                                        </tr>
                                    );
                                })
                            }
                        </tbody>
                    </table>
                }
            </div>
        </div>
    );
});

GroupHeadDealTracker.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
          ProjectId: PropTypes.number.isRequired,
          ProjectName: PropTypes.string.isRequired,
          Project: PropTypes.shape({
            Id: PropTypes.number.isRequired,
            Name: PropTypes.string.isRequired,
            Owner: PropTypes.shape({
              Id: PropTypes.number.isRequired,
              Name: PropTypes.string.isRequired,
            }).isRequired,
            Members: PropTypes.arrayOf(
              PropTypes.shape({
                Id: PropTypes.number.isRequired,
                Name: PropTypes.string.isRequired,
              })
            ).isRequired,
          }).isRequired,
          ProjectDynamicFields: PropTypes.arrayOf(
            PropTypes.shape({
              Label: PropTypes.string.isRequired,
              Data: PropTypes.string.isRequired,
            })
          ).isRequired,
          ProjectMembers: PropTypes.arrayOf(PropTypes.shape({
            UserId: PropTypes.string,
            AnalystAssociate: PropTypes.string,
            LastWeekHours: PropTypes.string,
            WeekendHours: PropTypes.string,
            TotalHours: PropTypes.string,
            CurrentWeekHours: PropTypes.string,
            Workload: PropTypes.string,
            LastUpdated: PropTypes.string
         })),
         GroupHeads: PropTypes.arrayOf(PropTypes.shape({
            Name: PropTypes.string.isRequired,
         })),
         AggregateLastWeekHours: PropTypes.string.isRequired,
         AggregateWeekendHours: PropTypes.string.isRequired,
         AggregateTotalHours: PropTypes.string.isRequired,
         AggregateCurrentWeekHours: PropTypes.string.isRequired,
         Description: PropTypes.string.isRequired,
         LastUpdated: PropTypes.string,
         QtyMembers: PropTypes.number.isRequired,
         Staffer: PropTypes.shape({
            Id: PropTypes.number.isRequired,
            Name: PropTypes.string.isRequired,
         }).isRequired,
        }),
    ).isRequired,
    title: PropTypes.string.isRequired,
    exportData: PropTypes.func,
    departmentTitle: PropTypes.string.isRequired,
    renderExtraColumns: PropTypes.func,
    renderModal: PropTypes.func.isRequired,
    exportDisabled: PropTypes.bool,
};

export default GroupHeadDealTracker;
